module.exports = __webpack_public_path__ + "media/Hillcrest Hall 3.c66dc339.mp3";